import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { SendResetPasswordLinkRequest } from '@/types/request/SendResetPasswordLinkRequest';

const useSendResetPasswordLink = () => {
  const client = supabaseClient;

  const mutationFn = async (request: SendResetPasswordLinkRequest) => {
    return sendResetPasswordLink(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useSendResetPasswordLink;

async function sendResetPasswordLink(client: SupabaseClient, request: SendResetPasswordLinkRequest): Promise<void> {
  const { error } = await client.functions.invoke('send_reset_password_link', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }

  return;
}
